var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 19.75V17.9167C18.3333 16.9442 17.947 16.0116 17.2593 15.3239C16.5717 14.6363 15.6391 14.25 14.6666 14.25H7.33329C6.36083 14.25 5.4282 14.6363 4.74057 15.3239C4.05293 16.0116 3.66663 16.9442 3.66663 17.9167V19.75",
    stroke: "#193566",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 10.5833C13.025 10.5833 14.6666 8.94171 14.6666 6.91667C14.6666 4.89162 13.025 3.25 10.9999 3.25C8.97487 3.25 7.33325 4.89162 7.33325 6.91667C7.33325 8.94171 8.97487 10.5833 10.9999 10.5833Z",
    stroke: "#193566",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.395d6456936ef5ca49df003059a0819a.svg";
export { ForwardRef as ReactComponent };